document.addEventListener('DOMContentLoaded', function () {
    const componentTabs = document.querySelectorAll('.component-tab-container'); // The container for all tabs

    if (componentTabs.length === 0) return;

    // Loop through each componentTabs container.
    componentTabs.forEach((container) => {
        const tabs = container.querySelectorAll('.component-tab'); // All tabs (including content)
        const tabsContainer = container.querySelector('.component-tab-container__tabs'); // Where we want to inject tab headings

        let maxHeight = 0; // Variable to store the max height of the tab headings
        const allHeadings = [];

        // Loop through each tab and inject the heading into the new container
        tabs.forEach((tab, index) => {
            const heading = tab.querySelector('.component-tab__heading'); // Find the heading
            const content = tab.querySelector('.component-tab__content'); // Find the content

            if (heading) {
                // Store each heading for later use
                allHeadings.push(heading);

                // Initially hide all tab content
                if (content) {
                    content.classList.add('hidden'); // Hide content initially
                    content.classList.remove('animate-fade-in-out'); // Ensure it's not shown initially
                }
            }
        });

        // Calculate the max height of the headings
        allHeadings.forEach(heading => {
            maxHeight = Math.max(maxHeight, heading.offsetHeight);
        });

        // Apply the max height to all tab headings
        allHeadings.forEach(heading => {
            heading.style.height = `${maxHeight}px`; // Apply maxHeight to each heading
        });

        // Move each tab heading to the container
        tabs.forEach((tab, index) => {
            const heading = tab.querySelector('.component-tab__heading'); // Find the heading
            const content = tab.querySelector('.component-tab__content'); // Find the content

            if (heading) {
                // Move the heading to the component-tab-container__tabs container
                tabsContainer.appendChild(heading);

                // Add click event listener to switch between tabs
                heading.addEventListener('click', () => switchTab(index, heading));
            }
        });

        // Function to handle switching tabs
        function switchTab(index, activeHeading) {
            const allContents = container.querySelectorAll('.component-tab__content');
            const allHeadings = container.querySelectorAll('.component-tab__heading');

            // Fade out current content
            allContents.forEach(content => {
                if (!content.classList.contains('hidden')) {
                    content.classList.remove('animate-fade-in-out'); // Start fade-out
                    setTimeout(() => {
                        content.classList.add('hidden'); // Completely hide content after fade-out
                    }, 300); // Match this time with the CSS transition duration
                }
            });

            // Remove active styles from all headings
            allHeadings.forEach(heading => {
                heading.classList.remove('border-b-[5px]', 'border-b-moss-80');
                heading.classList.add('border-b-[2px]');
            });

            // Show the content for the clicked tab and apply the active class to the heading
            const activeContent = allContents[index];
            setTimeout(() => {
                activeContent.classList.remove('hidden'); // Make it visible
                setTimeout(() => {
                    activeContent.classList.add('animate-fade-in-out'); // Apply fade-in effect
                }, 10); // Small delay to ensure visibility change before fade-in starts
            }, 300); // Wait for fade-out duration

            // Add active classes to the clicked heading
            activeHeading.classList.remove('border-b-[2px]');
            activeHeading.classList.add('border-b-[5px]', 'border-b-moss-80');
        }

        // Set the first tab as active on page load (remove content jump and unnecessary delay)
        setActiveTab(0);

        // Helper function to set the active tab
        function setActiveTab(index) {
            const firstTabContent = container.querySelectorAll('.component-tab__content')[index];
            const firstTabHeading = allHeadings[index];

            // Show the first tab content immediately without delay
            firstTabContent.classList.remove('hidden');
            firstTabContent.classList.add('animate-fade-in-out'); // Apply fade-in effect

            // Set the first heading as active
            firstTabHeading.classList.add('border-b-[5px]', 'border-b-moss-80');
        }
    });
});